import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import { motion } from "framer-motion";
import BlockAcademicOffer from "../components/BlockAcademicOffer";
import BlockRightImage from "../components/BlockRightImage";
import BlockLeftImage from "../components/BlockLeftImage";
function Decidesermas() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const url = "https://utpl.edu.ec/carreras/services/servicio-sermas.json";

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!url) {
          throw new Error("URL del servicio no proporcionada");
        }
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const jsonData = await response.json();
        setData(jsonData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]); // El array vacío significa que este efecto solo se ejecutará una vez al montar el componente

  if (loading) {
    return (
      <div className="margin graybg">
        <div className="padding layout6 ">
          {" "}
          <p>Cargando... </p>
        </div>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <div className="margin">
        <Breadcumbs
          content={
            <>
              <NavLink to="/decidesermas">Decide ser más</NavLink>
            </>
          }
        ></Breadcumbs>
      </div>
      <div className="layout8">
        <center>
          <h2 className="tag-sermas">
            Te unes al reto de <b>ser más</b>
          </h2>
        </center>
      </div>
      <BlockAcademicOffer></BlockAcademicOffer>

      {data.map((item, index) => (
        <div key={index}>
          <div className="bluebg padding">
            <div
              className="layout8"
              dangerouslySetInnerHTML={{ __html: item.field_texto_portada }}
            />
          </div>{" "}
          <BlockLeftImage
            src={item.field_imagen3}
            content={
              <>
                {" "}
                <div dangerouslySetInnerHTML={{ __html: item.field_bloque3 }} />
              </>
            }
          >
            {" "}
          </BlockLeftImage>
          <BlockRightImage
            src={item.field_imagen2}
            content={
              <>
                {" "}
                <div dangerouslySetInnerHTML={{ __html: item.field_bloque2 }} />
              </>
            }
          ></BlockRightImage>
        </div>
      ))}
    </>
  );
}

export default Decidesermas;
